export function readLeadCustomFields(stored) {
  return Array.isArray(stored) ? stored : typeof stored === 'string'
    ? [{ key: 'Custom field', value: stored }] : stored ? [stored] : [];
}

const canonical = value => value.normalize('NFKC').toLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
const reserved = new Set(['FullName', 'Full Name', 'Name', 'First name', 'Surname', 'Last name', 'Email', 'Tel', 'Phone', 'Telephone', 'City', 'Country', 'Amount', 'Column', 'Notes', 'id', '_id', '__proto__', 'constructor', 'prototype', 'Mail', 'Mobile', 'First', 'Last', 'Stage', 'Status', 'Note', 'Source', 'Date'].map(canonical));
export function getLeadCustomFieldsError(fields, t = value => value) {
  if (!Array.isArray(fields) || fields.length > 20) return t('Provide up to 20 custom fields');
  const used = new Set(reserved);
  for (const field of fields) {
    const key = typeof field?.key === 'string' ? field.key.trim() : '';
    if (!key || key.length > 80 || !canonical(key)) return t('Enter a field name of at most 80 characters');
    if (used.has(canonical(key))) return t('Use unique field names different from standard contact fields');
    used.add(canonical(key));
  }
  return '';
}

export const leadCustomFieldPayload = fields => fields.map(field => ({ key: field.key.trim(), value: field.value ?? '' }));
